import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { isNotEmpty, isNotNil } from 'ramda';

import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom';
import { SourceReferenceLink, SourceReferenceLinks } from '~/components/SourceReferenceLinks/SourceReferenceLinks';

export interface PurchaseOrderCellProps<R extends GridValidRowModel = any> {
  values?: SourceReferenceLink[];
  row?: R;
}

export const PurchaseOrderCell = <R extends GridValidRowModel = any>({ values }: PurchaseOrderCellProps<R>) => {
  return <>{isNotNil(values) && isNotEmpty(values) ? <SourceReferenceLinks values={values} /> : NULLISH_CELL_VALUE}</>;
};
